import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificationDetailDto } from '../../models/transaction-detail.model';
import { TransactionItem } from '../../models/item.model';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private _http = inject(HttpClient);

  getTransactionDetail(id: number): Observable<NotificationDetailDto> {
    return this._http.get<NotificationDetailDto>(`/api/transaction/${id}`);
  }

  updateItems(
    txId: number,
    items: TransactionItem[]
  ): Observable<{ success: boolean; resultText: string }> {
    return this._http
      .post<{ success: boolean; resultText: string }>(`/api/transaction/${txId}/items`, items);
  }
}